import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Import React Router
import { UserProvider } from './react-frontend/context/UserContext'; // Correct path for UserContext
import Footer from './react-frontend/components/Footer'; // Correct path for Footer
import Header from './react-frontend/components/Header'; // Correct path for HeaderComponent
import MainBody from './react-frontend/sections/mainbody'; // Changed from Main to MainBody
import ResetPassword from './react-frontend/components/ResetPassword'; // Correct path for ResetPassword
import SignUp from './react-frontend/components/SignUp'; // Import SignUp component
import UserPreferences from './react-frontend/components/UserPreferences'; // Import UserPreferences component
import Main from './react-frontend/sections/main'; // Add import for Main
import { LoadingProvider } from './react-frontend/context/LoadingContext';
import { Analytics } from './Analytics'; // Add Analytics import
import Testimonials from './react-frontend/components/Testimonials';
// import AdminCandidates from './react-frontend/components/AdminCandidates'; // Remove this import
// import SignInComponent from './react-frontend/components/SignInComponent'; // Correct path for SignInComponent

function App() {
  return (
    <LoadingProvider>
      <UserProvider>
        <Router>
          <div className="App">
            <Analytics /> {/* Add Analytics component */}
            <Header />
            <Routes>
              {/* MainBody as landing page */}
              <Route path="/" element={<MainBody />} />

              {/* Sign-in page */}
              {/* <Route path="/signin" element={<SignInComponent />} /> */}

              {/* Reset password page */}
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Signup page with invitation parameters */}
              <Route path="/signup" element={<SignUp />} />
              
              {/* User preferences page */}
              <Route path="/preferences" element={<UserPreferences />} />
              
              {/* Add Main route */}
              <Route path="/main" element={<Main />} />
              
              {/* Testimonials route */}
              <Route path="/testimonials" element={<Testimonials />} />
              
              {/* Admin routes - removed since we're using popups */}
              {/* <Route path="/admin/candidates" element={<AdminCandidates />} /> */}
            </Routes>
            <Footer />
          </div>
        </Router>
      </UserProvider>
    </LoadingProvider>
  );
}

export default App;
